import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard/resultado-por-empresa`

const ResultadoPorEmpresaHttp = {
  async getResultadoPorEmpresa(companyId, tpsIds, pInicial, pFinal) {
    try {
      const url =
        BASE_URL +
        `?tps_ids=${tpsIds}&company_id=${companyId}&pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
  
  async getMovimentacoesPerPage(companyId, tpsIds, pInicial, pFinal, page, all) {
    try {
      const url =
        BASE_URL +
        `/movimentacoes/?tps_ids=${tpsIds}&company_id=${companyId}&pInicial=${pInicial}&pFinal=${pFinal}&page=${page}` +
        (all ? `&all=${all}` : '')
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getMovimentacoesExcel(companyId, tpsIds, pInicial, pFinal) {
    try {
      const url =
        BASE_URL +
        `/movimentacoes/excel?tps_ids=${tpsIds}&company_id=${companyId}&pInicial=${pInicial}&pFinal=${pFinal}&t=${localStorage.getItem('t')}`
      return url
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default ResultadoPorEmpresaHttp
